/* eslint-disable import/extensions */

import { object } from 'yup'

import donorOwnerSchemas from '../DonorOwner/DonorOwner.schemas'
import iccSchemas from '../ICCField/ICCField.schemas'
import signUpTypeSchemas from '../SignUpType/SignUpType.schemas'

const SAME_DOC = 'El documento no puede ser el mismo que el principal.'

const signUpSchema = (customerId: string, isOffline: boolean) =>
  object().shape({
    ...signUpTypeSchemas,
    ...iccSchemas(isOffline),
    ...donorOwnerSchemas(customerId),
  })

export default signUpSchema
